import { useState, useEffect, useRef } from "react";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { calcImportacion, GLOBALES_DEFAULT, fmtUSD } from "../../utils/ddp";

const G={bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",border2:"#D4D0CA",
  black:"#1C1917",off:"#3D3830",muted:"#8C8078",
  orange:"#D2611A",green:"#16A34A",red:"#DC2626",blue:"#2563EB",
  sans:"'Outfit','Helvetica Neue',Arial,sans-serif",
  mono:"'IBM Plex Mono',monospace"};
const O="#D2611A", BK="#1C1917";
const RUBROS=["Sanitarios","Bañeras","Vanitorys","Pisos SPC","Hornos y Anafes","Puertas","Carpintería","Cocinas","Barandas y Balcones"];
const FLETE_MIN=3800, FLETE_MAX=9200;

// ── Slider de fotos ───────────────────────────────────────────────────────────
function SliderFotos({fotos,nombre}){
  const[idx,setIdx]=useState(0);
  const touch=useRef(null);
  if(!fotos.length) return <div style={{height:280,background:G.s2,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:G.sans,fontSize:11,color:G.muted}}>Sin imagen</div>;
  return(
    <div style={{position:"relative",background:G.s2}}
      onTouchStart={e=>touch.current=e.touches[0].clientX}
      onTouchEnd={e=>{if(!touch.current)return;const d=touch.current-e.changedTouches[0].clientX;if(Math.abs(d)>40)setIdx(i=>d>0?(i+1)%fotos.length:(i-1+fotos.length)%fotos.length);touch.current=null;}}>
      <div style={{height:280,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>
        <img src={fotos[idx]} alt={nombre} style={{maxWidth:"100%",maxHeight:280,objectFit:"contain"}}/>
      </div>
      {fotos.length>1&&<>
        <button onClick={e=>{e.stopPropagation();setIdx(i=>(i-1+fotos.length)%fotos.length);}} style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)",background:"rgba(28,25,23,.6)",color:"#fff",border:"none",width:32,height:32,cursor:"pointer",fontSize:16,borderRadius:4}}>‹</button>
        <button onClick={e=>{e.stopPropagation();setIdx(i=>(i+1)%fotos.length);}} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"rgba(28,25,23,.6)",color:"#fff",border:"none",width:32,height:32,cursor:"pointer",fontSize:16,borderRadius:4}}>›</button>
        <div style={{position:"absolute",bottom:8,left:0,right:0,display:"flex",justifyContent:"center",gap:5}}>
          {fotos.map((_,i)=><div key={i} onClick={e=>{e.stopPropagation();setIdx(i);}} style={{width:i===idx?18:6,height:6,background:i===idx?O:"rgba(255,255,255,.5)",borderRadius:3,cursor:"pointer",transition:"all .3s"}}/>)}
        </div>
      </>}
      {fotos.length>1&&<div style={{display:"flex",gap:5,padding:"6px 8px",overflowX:"auto",background:G.s2}}>
        {fotos.map((url,i)=><img key={i} src={url} alt="" onClick={e=>{e.stopPropagation();setIdx(i);}} style={{width:44,height:44,objectFit:"contain",background:G.s1,cursor:"pointer",border:i===idx?`2px solid ${O}`:`1px solid ${G.border}`,flexShrink:0,borderRadius:2}}/>)}
      </div>}
    </div>
  );
}

// ── Calculadora de flete ──────────────────────────────────────────────────────
function CalculadoraFlete({producto,globales}){
  const[flete,setFlete]=useState("");
  const[resultado,setResultado]=useState(null);
  const[resMin,setResMin]=useState(null);
  const[resMax,setResMax]=useState(null);
  const g=globales||GLOBALES_DEFAULT;

  useEffect(()=>{
    if(!producto?.fob_compra||!producto?.cbm)return;
    const base={fob_compra:producto.fob_compra,fob_declarado:producto.fob_declarado||producto.fob_compra,cbm:producto.cbm,rubro:producto.rubro};
    setResMin(calcImportacion({...base,globales:{...g,flete_real:FLETE_MIN}}));
    setResMax(calcImportacion({...base,globales:{...g,flete_real:FLETE_MAX}}));
  },[producto,globales]);

  const calcular=(val)=>{
    setFlete(val);
    const f=parseFloat(val);
    if(!f||!producto?.fob_compra||!producto?.cbm){setResultado(null);return;}
    setResultado(calcImportacion({fob_compra:producto.fob_compra,fob_declarado:producto.fob_declarado||producto.fob_compra,cbm:producto.cbm,rubro:producto.rubro,globales:{...g,flete_real:f}}));
  };

  if(!producto?.fob_compra||!producto?.cbm) return null;

  return(
    <div style={{background:G.s2,border:`1.5px solid ${G.border}`,padding:18,marginTop:14}}>
      <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:12,fontWeight:600}}>Calculadora — variá el flete</div>

      {/* Campo flete */}
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,flex:1,minWidth:160,background:G.s1,border:`1.5px solid ${flete?O:G.border}`,padding:"8px 12px"}}>
          <span style={{fontFamily:G.mono,fontSize:11,color:G.muted}}>USD</span>
          <input type="number" value={flete} onChange={e=>calcular(e.target.value)} placeholder="Ej: 5.000"
            style={{flex:1,background:"transparent",border:"none",outline:"none",fontFamily:G.mono,fontSize:16,color:BK,fontWeight:600}}/>
          <span style={{fontFamily:G.mono,fontSize:9,color:G.muted}}>/40HC</span>
        </div>
        <button onClick={()=>calcular(FLETE_MIN)} style={{padding:"8px 12px",background:"transparent",border:`1.5px solid ${G.border}`,fontFamily:G.sans,fontSize:9,color:G.muted,cursor:"pointer",letterSpacing:1.5,textTransform:"uppercase",fontWeight:600}}>
          Mín<br/><span style={{fontFamily:G.mono,fontSize:10,color:O}}>USD {FLETE_MIN.toLocaleString()}</span>
        </button>
        <button onClick={()=>calcular(FLETE_MAX)} style={{padding:"8px 12px",background:"transparent",border:`1.5px solid ${G.border}`,fontFamily:G.sans,fontSize:9,color:G.muted,cursor:"pointer",letterSpacing:1.5,textTransform:"uppercase",fontWeight:600}}>
          Máx<br/><span style={{fontFamily:G.mono,fontSize:10,color:BK}}>USD {FLETE_MAX.toLocaleString()}</span>
        </button>
      </div>

      {/* Resultado */}
      {resultado&&(
        <div style={{marginBottom:14}}>
          {[
            {l:"FOB origen",v:resultado.fob_real_unit},
            {l:"Logística proporcional",v:resultado.suma_b},
            {l:"Aranceles e impuestos",v:resultado.suma_aduana-resultado.fob_real_unit},
            {l:"IVA 21% (recuperable)",v:resultado.iva,tag:"RECUP."},
          ].map((d,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${G.border}`}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontFamily:G.sans,fontSize:11,color:G.muted}}>{d.l}</span>
                {d.tag&&<span style={{fontFamily:G.mono,fontSize:7,color:G.orange,border:`0.5px solid ${G.orange}`,padding:"1px 4px"}}>{d.tag}</span>}
              </div>
              <span style={{fontFamily:G.mono,fontSize:11,color:G.off}}>{fmtUSD(d.v)}</span>
            </div>
          ))}
          <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",background:"#FEF3E8",padding:"10px 12px",marginTop:6}}>
            <span style={{fontFamily:G.sans,fontSize:13,color:BK,fontWeight:700}}>Total c/IVA / {producto.unidad}</span>
            <span style={{fontFamily:G.mono,fontSize:16,color:O,fontWeight:700}}>{fmtUSD(resultado.costo_total_unit)}</span>
          </div>
        </div>
      )}

      {/* Rango min/max */}
      {resMin&&resMax&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
          <div style={{background:G.s1,border:`1px solid ${G.border}`,padding:"10px 12px"}}>
            <div style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:3,fontWeight:600}}>Flete mínimo<br/><span style={{color:O}}>USD {FLETE_MIN.toLocaleString()}</span></div>
            <div style={{fontFamily:G.mono,fontSize:16,color:O,fontWeight:700}}>{fmtUSD(resMin.costo_total_unit)}</div>
            <div style={{fontFamily:G.mono,fontSize:9,color:G.muted}}>/ {producto.unidad} c/IVA</div>
          </div>
          <div style={{background:G.s1,border:`1px solid ${G.border}`,padding:"10px 12px"}}>
            <div style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:3,fontWeight:600}}>Flete máximo<br/><span style={{color:BK}}>USD {FLETE_MAX.toLocaleString()}</span></div>
            <div style={{fontFamily:G.mono,fontSize:16,color:BK,fontWeight:700}}>{fmtUSD(resMax.costo_total_unit)}</div>
            <div style={{fontFamily:G.mono,fontSize:9,color:G.muted}}>/ {producto.unidad} c/IVA</div>
          </div>
        </div>
      )}

      {/* Leyenda */}
      <div style={{background:"#FEF3E8",border:`1px solid ${O}33`,padding:"10px 12px",borderRadius:2}}>
        <div style={{fontFamily:G.sans,fontSize:10,color:G.off,lineHeight:1.65}}>
          <strong style={{color:O}}>⚠ El precio final depende del flete vigente.</strong><br/>
          El contenedor 40HC varía entre <strong>USD 3.800 y USD 9.200</strong> según temporada y naviera. El precio definitivo se confirma al abrir el ciclo.
        </div>
      </div>
    </div>
  );
}

// ── Modal detalle producto ────────────────────────────────────────────────────
function DetalleProducto({producto,onClose,globales}){
  useEffect(()=>{
    const y=window.scrollY;
    document.body.style.cssText=`overflow:hidden;position:fixed;width:100%;top:-${y}px`;
    return()=>{document.body.style.cssText="";window.scrollTo(0,y);};
  },[]);

  const fotos=[producto.imagen_url,...(producto.imagenes||[]).filter(u=>u&&u!==producto.imagen_url)].filter(Boolean);
  const bullets=(producto.caracteristicas||"").split("\n").map(l=>l.replace(/^[•\-\*]\s*/,"").trim()).filter(Boolean);
  const precio=producto.precio_venta;
  const precioIVA=precio?(precio*1.21).toFixed(2):null;
  const msgWA=encodeURIComponent(`Hola, me interesa cotizar: ${producto.nombre}${precioIVA?` (USD ${precioIVA} con IVA)`:""}.`);
  const esMedida=["Carpintería","Cocinas","Barandas y Balcones"].includes(producto.rubro);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(28,25,23,.72)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:12}} onClick={onClose}>
      <div style={{background:G.s1,width:"100%",maxWidth:900,maxHeight:"92vh",overflowY:"auto",display:"grid",gridTemplateColumns:"1fr 1fr"}} onClick={e=>e.stopPropagation()}>
        <SliderFotos fotos={fotos} nombre={producto.nombre}/>
        <div style={{padding:20,display:"flex",flexDirection:"column",gap:12,overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div style={{flex:1,paddingRight:8}}>
              <div style={{fontFamily:G.sans,fontSize:8,color:O,letterSpacing:2,textTransform:"uppercase",marginBottom:3,fontWeight:600}}>{producto.rubro}</div>
              <div style={{fontFamily:G.sans,fontSize:"clamp(14px,3vw,18px)",color:BK,fontWeight:700,lineHeight:1.2}}>{producto.nombre}</div>
              {producto.sku&&<div style={{fontFamily:G.mono,fontSize:9,color:G.muted,marginTop:2}}>{producto.sku}</div>}
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",fontSize:22,color:G.muted,cursor:"pointer"}}>×</button>
          </div>

          {esMedida&&(
            <div style={{background:"#EFF6FF",border:"1px solid #2563EB33",padding:"10px 14px"}}>
              <div style={{fontFamily:G.sans,fontSize:11,color:"#1D4ED8",fontWeight:700,marginBottom:3}}>✦ Diseño a medida</div>
              <div style={{fontFamily:G.sans,fontSize:10,color:"#3730A3",lineHeight:1.5}}>Trabajamos en cooperación con la fábrica. Cualquier medida, color o diseño. Enviá tus planos.</div>
            </div>
          )}

          {precioIVA?(
            <div style={{background:"#FEF3E8",border:`1.5px solid ${O}`,padding:12}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <div>
                  <div style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:3,fontWeight:600}}>Sin IVA</div>
                  <div style={{fontFamily:G.mono,fontSize:16,color:BK,fontWeight:700}}>USD {Number(precio).toLocaleString("es-AR",{minimumFractionDigits:2})} / {producto.unidad}</div>
                </div>
                <div>
                  <div style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,textTransform:"uppercase",color:O,marginBottom:3,fontWeight:600}}>Con IVA</div>
                  <div style={{fontFamily:G.mono,fontSize:16,color:O,fontWeight:700}}>USD {Number(precioIVA).toLocaleString("es-AR",{minimumFractionDigits:2})}</div>
                </div>
              </div>
            </div>
          ):(
            <div style={{background:G.s2,border:`1px solid ${G.border}`,padding:12,fontFamily:G.sans,fontSize:11,color:G.off}}>
              {esMedida?"Precio según medidas y especificaciones.":"Precio a cotizar según especificaciones."}
            </div>
          )}

          {/* Calculadora */}
          <CalculadoraFlete producto={producto} globales={globales}/>

          {bullets.length>0&&(
            <div>
              <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:8,fontWeight:600}}>Especificaciones</div>
              {bullets.map((b,i)=><div key={i} style={{display:"flex",gap:8,alignItems:"flex-start",padding:"5px 0",borderBottom:`1px solid ${G.border}`}}>
                <span style={{color:O,fontWeight:700,flexShrink:0,fontSize:11}}>→</span>
                <span style={{fontFamily:G.sans,fontSize:11,color:G.off}}>{b}</span>
              </div>)}
            </div>
          )}

          <div style={{display:"flex",flexDirection:"column",gap:8,marginTop:"auto"}}>
            <a href={`https://wa.me/5491150614489?text=${msgWA}`} target="_blank" rel="noreferrer"
              style={{display:"block",width:"100%",padding:12,background:"#25D366",color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",fontWeight:700,textAlign:"center",textDecoration:"none",borderRadius:2}}>
              ↗ Cotizar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Tarjeta producto ──────────────────────────────────────────────────────────
function TarjetaProducto({producto,onClick}){
  const[h,setH]=useState(false);
  const precio=producto.precio_venta;
  const precioIVA=precio?(precio*1.21).toFixed(2):null;
  return(
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} onClick={onClick}
      style={{background:G.s1,border:`1.5px solid ${h?O:G.border}`,cursor:"pointer",transition:"all .2s",overflow:"hidden",boxShadow:h?"0 4px 14px rgba(210,97,26,.1)":"none"}}>
      <div style={{aspectRatio:"4/3",overflow:"hidden",background:G.s2,display:"flex",alignItems:"center",justifyContent:"center"}}>
        {producto.imagen_url
          ?<img src={producto.imagen_url} alt={producto.nombre} style={{maxWidth:"100%",maxHeight:"100%",objectFit:"contain",transform:h?"scale(1.04)":"scale(1)",transition:"transform .4s"}}/>
          :<div style={{fontFamily:G.sans,fontSize:10,color:G.muted}}>Sin imagen</div>
        }
      </div>
      <div style={{padding:"10px 12px 14px"}}>
        <div style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,textTransform:"uppercase",color:O,marginBottom:3,fontWeight:600}}>{producto.rubro}</div>
        <div style={{fontFamily:G.sans,fontSize:"clamp(11px,2vw,13px)",color:BK,fontWeight:700,lineHeight:1.3,marginBottom:6}}>{producto.nombre}</div>
        {precioIVA
          ?<div style={{fontFamily:G.mono,fontSize:"clamp(11px,2vw,13px)",color:O,fontWeight:700}}>USD {Number(precioIVA).toLocaleString("es-AR",{minimumFractionDigits:2})} / {producto.unidad}</div>
          :<div style={{fontFamily:G.sans,fontSize:9,color:G.muted,textTransform:"uppercase",letterSpacing:1}}>Cotización personalizada</div>
        }
      </div>
      {h&&<div style={{height:2,background:O}}/>}
    </div>
  );
}

// ── PANEL PRINCIPAL ───────────────────────────────────────────────────────────
export default function CompradorCatalogo(){
  const[productos,setProductos]=useState([]);
  const[loading,setLoading]=useState(true);
  const[rubro,setRubro]=useState(null);
  const[busqueda,setBusqueda]=useState("");
  const[detalle,setDetalle]=useState(null);
  const[globales,setGlobales]=useState(null);

  useEffect(()=>{
    Promise.all([
      getDocs(collection(db,"productos")),
      getDoc(doc(db,"configuracion","globales")),
    ]).then(([snap,gSnap])=>{
      const items=snap.docs.map(d=>({id:d.id,...d.data()}))
        .filter(p=>p.publicado!==false)
        .sort((a,b)=>(a.orden||999)-(b.orden||999)||(a.nombre||"").localeCompare(b.nombre||""));
      setProductos(items);
      if(gSnap.exists())setGlobales(gSnap.data());
      setLoading(false);
    }).catch(()=>setLoading(false));
  },[]);

  const rubrosConProductos=RUBROS.filter(r=>productos.some(p=>p.rubro===r));
  const filtrados=productos.filter(p=>{
    const mR=rubro===null||p.rubro===rubro;
    const mB=!busqueda||p.nombre?.toLowerCase().includes(busqueda.toLowerCase());
    return mR&&mB;
  });
  const porCategorias=rubrosConProductos.map(r=>({rubro:r,items:filtrados.filter(p=>p.rubro===r)})).filter(g=>g.items.length>0);

  return(
    <div>
      {/* Encabezado */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:G.sans,fontSize:22,color:BK,fontWeight:700,marginBottom:3}}>Catálogo</div>
          <div style={{fontFamily:G.mono,fontSize:10,color:G.muted}}>{productos.length} productos · Precios con IVA · Flete variable</div>
        </div>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar productos..."
          style={{padding:"7px 12px",border:`1px solid ${G.border}`,fontFamily:G.sans,fontSize:12,color:BK,background:G.s1,outline:"none",width:220}}/>
      </div>

      {/* Filtros */}
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:20}}>
        <button onClick={()=>setRubro(null)}
          style={{padding:"5px 14px",fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",background:rubro===null?O:G.s1,color:rubro===null?"#fff":G.muted,border:`1.5px solid ${rubro===null?O:G.border}`,cursor:"pointer",fontWeight:rubro===null?700:500}}>
          Todos ({productos.length})
        </button>
        {rubrosConProductos.map(r=>(
          <button key={r} onClick={()=>setRubro(rubro===r?null:r)}
            style={{padding:"5px 14px",fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",background:rubro===r?O:G.s1,color:rubro===r?"#fff":G.muted,border:`1.5px solid ${rubro===r?O:G.border}`,cursor:"pointer",fontWeight:rubro===r?700:500}}>
            {r}
          </button>
        ))}
      </div>

      {/* Aviso flete */}
      <div style={{background:"#FEF3E8",border:`1px solid ${O}33`,padding:"10px 16px",marginBottom:20,fontFamily:G.sans,fontSize:11,color:G.off,lineHeight:1.5}}>
        ⚠ Los precios son orientativos. El costo final varía según el flete vigente del contenedor 40HC (USD 3.800–9.200). <strong>Abrí cada producto para calcular el costo con el flete que necesitás.</strong>
      </div>

      {loading?(
        <div style={{padding:40,textAlign:"center",fontFamily:G.sans,fontSize:12,color:G.muted}}>Cargando...</div>
      ):rubro!==null||busqueda?(
        filtrados.length===0?(
          <div style={{padding:40,textAlign:"center",fontFamily:G.sans,fontSize:13,color:G.muted}}>
            Sin productos. <span style={{color:O,cursor:"pointer"}} onClick={()=>{setRubro(null);setBusqueda("");}}>Ver todos →</span>
          </div>
        ):(
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:14}}>
            {filtrados.map(p=><TarjetaProducto key={p.id} producto={p} onClick={()=>setDetalle(p)}/>)}
          </div>
        )
      ):(
        porCategorias.map(({rubro:r,items})=>(
          <div key={r} style={{marginBottom:36}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,paddingBottom:10,borderBottom:`2px solid ${G.border}`}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:4,height:24,background:O}}/>
                <div>
                  <h3 style={{fontFamily:G.sans,fontSize:18,fontWeight:700,color:BK}}>{r}</h3>
                  <div style={{fontFamily:G.mono,fontSize:9,color:G.muted}}>{items.length} producto{items.length!==1?"s":""}</div>
                </div>
              </div>
              <button onClick={()=>setRubro(r)} style={{fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",color:O,background:"transparent",border:`1px solid ${O}`,padding:"5px 12px",cursor:"pointer",fontWeight:600}}>
                Ver solo {r} →
              </button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:12}}>
              {items.map(p=><TarjetaProducto key={p.id} producto={p} onClick={()=>setDetalle(p)}/>)}
            </div>
            {/* CTA consultar */}
            <div style={{marginTop:12,padding:"12px 16px",background:G.s2,border:`1px solid ${G.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <div style={{fontFamily:G.sans,fontSize:11,color:G.muted}}>¿No encontrás el modelo o color? Tenemos acceso a muchos más.</div>
              <a href={`https://wa.me/5491150614489?text=${encodeURIComponent(`Hola, busco ${r} y quiero consultar otros modelos disponibles.`)}`}
                target="_blank" rel="noreferrer"
                style={{padding:"7px 14px",background:O,color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,textDecoration:"none",whiteSpace:"nowrap"}}>
                Consultar →
              </a>
            </div>
          </div>
        ))
      )}

      {detalle&&<DetalleProducto producto={detalle} onClose={()=>setDetalle(null)} globales={globales}/>}
    </div>
  );
}
